import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { LinearProgress } from '@material-ui/core';
import { isArray } from 'lodash';
import moment from 'moment';

import { t } from '~/helpers';
import api from '~/services/api';

import Header from './components/Header';
import Table from './components/Table';
import * as S from './styles';

function AderenciaProduto() {
  const [loading, setLoading] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [minimo, setMinimo] = useState(0.4);
  const [meta, setMeta] = useState(0.2);
  const [maximo, setMaximo] = useState(0.08);
  const [d1, setD1] = useState('');
  const [mes, setMes] = useState('');
  const [ano, setAno] = useState('');

  const header = useMemo(() => {
    const agora = moment();

    return {
      produto: 1,
      iniciomes: agora.clone().startOf('month').format('DD/MM/YYYY 00:00:00'),
      inicioano: moment({ year: agora.year(), month: 0, day: 1 }).format(
        'DD/MM/YYYY 00:00:00'
      ),
    };
  }, []);

  const handleSubmitHeader = useCallback(
    async ({ produto, iniciomes, inicioano }) => {
      if (!produto || !produto.idproduto || !produto.tipoproduto) return;

      try {
        setLoading(true);
        const { data } = await api.get('turnos/indicadoroperacaoaderencia', {
          params: {
            /* tipo, */
            idproduto: produto.idproduto,
            datahorainiciomes: moment(iniciomes, 'DD/MM/YYYY').format(
              'YYYY-MM-DD 00:00:00'
            ),
            datahorainicioano: moment(inicioano, 'DD/MM/YYYY').format(
              'YYYY-MM-DD 00:00:00'
            ),
          },
        });

        if (produto.tipoproduto === 'C') {
          setMinimo(0.4);
          setMeta(0.2);
          setMaximo(0.08);
        } else if (produto.tipoproduto === 'L') {
          setMinimo(1.0);
          setMeta(0.6);
          setMaximo(0.3);
        }

        setD1(moment().subtract(1, 'day').format('DD/MM/YYYY'));
        setMes(moment(iniciomes, 'DD/MM/YYYY').format('MM/YYYY'));
        setAno(moment(inicioano, 'DD/MM/YYYY').format('YYYY'));

        setDataTable(data);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    }
  );

  return (
    <S.Wrapper>
      {loading && <LinearProgress />}
      <Header
        minimo={minimo}
        meta={meta}
        maximo={maximo}
        data={header}
        handleSubmit={handleSubmitHeader}
      />

      <Table d1={d1} mes={mes} ano={ano} meta={meta} data={dataTable} />
    </S.Wrapper>
  );
}

export default AderenciaProduto;
